/**
 * UncategorizedFolder - Special card for displaying uncategorized sessions
 */

import { Badge } from '@/components/ui/badge';

interface UncategorizedFolderProps {
  sessionCount: number;
  onClick: () => void;
}

export function UncategorizedFolder({ sessionCount, onClick }: UncategorizedFolderProps) {
  if (sessionCount === 0) return null;

  return (
    <div
      onClick={onClick}
      className="border-2 border-dashed border-[#CED4DE] rounded-lg p-4 hover:shadow-md hover:border-[#12356B]/60 transition-all cursor-pointer bg-white h-full flex flex-col"
    >
      {/* Folder icon */}
      <div className="flex items-center gap-2.5 mb-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-7 w-7 text-slate-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
          />
        </svg>
        <h3 className="text-base font-semibold text-[#12356B]">Uncategorized</h3>
      </div>

      {/* Description */}
      <p className="text-sm text-slate-600 mb-3">
        Sessions not assigned to any class
      </p>

      {/* Session count badge */}
      <div className="mt-auto">
        <Badge variant="secondary">
          {sessionCount} {sessionCount === 1 ? 'session' : 'sessions'}
        </Badge>
      </div>
    </div>
  );
}
